import React from 'react';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

export function DescriptionIcon() {
  return <DescriptionOutlinedIcon fontSize="small" />;
}
